import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { first } from 'rxjs/internal/operators/first';
import { Router } from '@angular/router';
import { RouterConstants } from '../../../../../core/routing/constants/app-paths.constant';

import { CommonService } from '../../../../../common/services/common.service';
import { HeroTileService } from '../../../../../core/routing/services/asset-library/hero-tile.service';
import { GlobalConstants } from '../../../../../common/constants/global.constant';
import { DataService } from '../../../../../core/data/data-service';
import { DomSanitizer } from '@angular/platform-browser';
import { AssetLibraryConstants } from '../../../../../core/routing/services/asset-library/constants/asset-library.constant';
import { ImageUploadData } from '../interfaces/hero-tile.i';
import { FormFactor } from '../../../form-factors/interfaces/form-factors.i';
import { Utils } from 'src/app/common/utils/utils';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../../../environments/environment';
import { AppGlobal } from '../../../../../core/state/app-global';
import { User } from '../../../../account/login/_models/user.model';
import { CreateProfileService } from '../../../../../core/routing/services/profile/create-profile.service';
import { ProfileStoreService } from '../../../../../modules/create-profile/store/profile.store';
import { CreateCustomTileResponse } from '../../../hero-tile/hero-tile/interfaces/hero-tile.i';
import { PageComponent } from '../../../page/page.component';

@Component({
  selector: 'iposcen-custom-tile',
  templateUrl: './custom-tile.component.html',
  styleUrls: ['./custom-tile.component.scss']
})
export class CustomTileComponent implements OnInit {
  @ViewChild('formFactorsModal') formFactorsModal: ElementRef;
  @ViewChild('enableUrl') docUrl: ElementRef;
  @ViewChild('enablePages') docPages: ElementRef;
  @ViewChild('showModal') showModal: ElementRef;
  @ViewChild('applyModal') applyModal: ElementRef;
  @ViewChild('page1') page1: PageComponent;
  @ViewChild('page2') page2: PageComponent;
  @ViewChild('page3') page3: PageComponent;
  @Output() refresh = new EventEmitter();
  @Output() showOnDeviceTile = new EventEmitter();
  @Output() closeCustomDevice = new EventEmitter();
  @Input() editObject;
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId
  globalConstant = GlobalConstants;
  assetLibrabyConstant = AssetLibraryConstants;
  publishValue: string;
  internalValue: string;
  callToAction: string;
  urlInput: string;
  customTileInfo: boolean;
  isPublishDateCustomDatepickerCustomTile = false;
  customPublishDateResultCustomTile: string;
  isCustomPublishDateCorrectCustomTile: boolean;
  editPublishDateInfoCustomTile: string;
  isCustomExpiryDateCorrectCustomTile: boolean;
  customExpiryDateResultCustomTile: string;
  isExpiryDatePickerCustomTile: boolean;
  editexpiryDateInfoCustomTile: string;
  isExpiredDateIncorrectCustomTile: boolean;
  selectedFormFactors: FormFactor;
  errorMessagePublish = {};
  errorMessageinternal = {};
  errorMessageBannerImage;
  errorMessageMainImage;
  errorUrlExp;
  errorMessageCallToAction = {};
  imageMainData: ImageUploadData;
  imageBannerData: ImageUploadData;
  mainTileFunction = true; // true : pages, false : URL exp
  livePreview;
  deviceTypes = GlobalConstants.DEVICE_TYPES;
  manufacturers = GlobalConstants.MANUFACTURERS;
  processors = GlobalConstants.PROCESSORS;
  generation = GlobalConstants.GENERATION;
  mainSaveDone: boolean;
  getAllInputs;
  deviceExists: boolean;
  //Pages dependent var
  pages: any; // update the no of pages for edit.
  mediaObjects: any[] = [];
  pageError = new Map([[1, false], [2, false], [3, false]]);
  buttonLable = GlobalConstants.OK_BUTTON;
  profileName: string;
  errorMessageText = GlobalConstants.PAGE_ERROR_MESSAGE;
  errorMessageText1 = GlobalConstants.PAGE_ERROR_MESSAGE1;
  errorMessageText2 = GlobalConstants.PAGE_ERROR_MESSAGE2;
  errorMessageText3 = GlobalConstants.PAGE_ERROR_MESSAGE3;
  errorMessageText4 = GlobalConstants.PAGE_ERROR_MESSAGE4;
  errorMessageText5 = GlobalConstants.PAGE_ERROR_MESSAGE5;
  errorMessageText6 = GlobalConstants.PAGE_ERROR_MESSAGE6;
  isRegionalHQ: boolean;
  tabIndex = 0;
  isPage3Created: boolean;
  pageType = GlobalConstants.CUSTOM_TILE_GROUP;
  LCGlayout = 1;
  page = 1;
  contentGrpData: any;
  configarationEdit;
  isRemoveEnabled: boolean;
  clickable = false; // This is to enable tabs click only after clicking on Save & Proceed.TODO: will remove this later.
  presentPage: string;
  profile_page: string = GlobalConstants.PROFILE;
  currentdetailPage: string;
  profileID: string;
  config;
  private ngUnsubscribe = new Subject<boolean>();
  newID: any;
  divideDateFormat: boolean = true;
  isCustomPublishTimeZoneSelected = false;
  isCustomExpiryTimeZoneSelected = false;
  assets_page: string = GlobalConstants.ASSET_LIBRARY;
  direction: string;
  whichPageDelete: any;
  pagelen: number;
  bgColor: string;
  gamingBgColor: string;
  showPreviewLayout: boolean;
  constructor(
    private router: Router,
    private dataService: DataService,
    private heroTileService: HeroTileService,
    private sanitizer: DomSanitizer,
    private cmnSer: CommonService,
    private modalService: NgbModal,
    private appGlobal: AppGlobal,
    private createProfileService: CreateProfileService,
    private profileStoreService: ProfileStoreService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.direction = this.commonService.direction;
    //To know in which page this component used in
    this.currentdetailPage = this.router.url;
    const pageName = this.currentdetailPage.lastIndexOf('/');
    if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.ASSET_LIBRARY) {
      this.presentPage = GlobalConstants.ASSET_LIBRARY;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE ||
      this.currentdetailPage.includes(RouterConstants.EDIT_PROFILE)) {
      this.presentPage = GlobalConstants.PROFILE;
    }
    this.cmnSer.pageObser
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data) => {
      if(data.media.format === 'video/mp4' && ((data.previewType === GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS && data.fullScreenCheckbox) || (data.previewType === GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE && data.idleExpFullscreenEnabled))) {
        this.showPreviewLayout = false;
      } else {
        this.showPreviewLayout = true;
      }
    });     
    //To Subscribe pages changes.
    this.cmnSer.pageDataTologoObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        // Once page is updated.
        const customHeroTileContent = this.contentGrpData.customHeroTile;
        let configurations = customHeroTileContent.configurations;
        if (res.data.media.url !== '') {
          this.prepareMediaSet(res, customHeroTileContent.id);
        }
        const checkJson = this.checkExistance(configurations.contentGroupPages, 'pageNum', res.number);
        if (checkJson.hasMatch) {// If there is configuration object already for the page number
          // Update the pages
          configurations.contentGroupPages[checkJson.matchedIndex] = {
            pageNum: res.number,
            title: res.data.heading,
            titleFontColor: res.data.hcolor,
            bgColor: res.data.bgcolor,
            gamingBgColor: res.data.gamingBgColor,
            bodyCopy: res.data.body,
            bodyCopyFontSize: this.fontSizeNumber(res.data.size),
            bodyCopyFontColor: res.data.bcolor,
            UiLayout: this.getUILayoutNameByID(res.data.layout),
            linkedAsset: res.data.media.url !== '' ? true : false,
            linkedAssetFileType: res.data.media.format,
            fileName: res.data.media.name,
            fullScreenCheckbox: res.data.fullScreenCheckbox,
          };
        } else {
          const customHeroTileGroupPage = {
            pageNum: res.number,
            title: res.data.heading,
            titleFontColor: res.data.hcolor,
            bgColor: res.data.bgcolor,
            gamingBgColor: res.data.gamingBgColor,
            bodyCopy: res.data.body,
            bodyCopyFontSize: this.fontSizeNumber(res.data.size),
            bodyCopyFontColor: res.data.bcolor,
            UiLayout: this.getUILayoutNameByID(res.data.layout),
            linkedAsset: res.data.media.url !== '' ? true : false,
            linkedAssetFileType: res.data.media.format,
            fileName: res.data.media.name,
            fullScreenCheckbox: res.data.fullScreenCheckbox,
          };
          configurations.contentGroupPages.push(customHeroTileGroupPage);
        }
        this.contentGrpData.customHeroTile = customHeroTileContent;
        this.cmnSer.setRetailGifValue(false);
      });
    this.initialValue();
    this.pages = {};
    if (this.editObject) {
      if (this.editObject?.configurations?.isPublishDateNow) {
        this.isPublishDateCustomDatepickerCustomTile = false;
        this.editPublishDateInfoCustomTile = GlobalConstants.NOW;
      } else if (this.editObject?.configurations?.publishTime) {
        this.isPublishDateCustomDatepickerCustomTile = true;
        this.customPublishDateResultCustomTile = this.editObject?.configurations?.publishTime;
        this.editPublishDateInfoCustomTile = this.editObject?.configurations?.publishTime;
      }
      if (this.editObject?.configurations?.isPublishExpiryNever) {
        this.isExpiryDatePickerCustomTile = false;
        this.editexpiryDateInfoCustomTile = GlobalConstants.NEVER;
      } else if (this.editObject?.configurations?.expireTime) {
        this.isExpiryDatePickerCustomTile = true;
        this.customExpiryDateResultCustomTile = this.editObject?.configurations?.expireTime;
        this.editexpiryDateInfoCustomTile = this.editObject?.configurations?.expireTime;
      }
      this.editPreFill();
    }
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userAccount: User) => {
        this.isRemoveEnabled = userAccount.isRemoveEnabled;
      });
      this.cmnSer.getRetailGifValue
       .pipe(takeUntil(this.ngUnsubscribe))
       .subscribe(data => {
         if (data === true) {
           this.cmnSer.setSwitchstatus(true);
         }
       });
  }
  
  initialValue(which?) {
    // if parameter is not given it will reset all 
    const livePreviewInit = {
      image: {
        name: '',
        url: '',
        format: ''
      },
      button: {
        value: this.assetLibrabyConstant.CALL_TO_ACTION_CUSTOM_PLACEHOLDER
      }
    }
    const errorInit = {
      sizeError: false,
      typeError: false,
      fileError: false,
      isError: false
    }
    const file = {
      url: '',
      file: '',
      fileName: ''
    }
    const selectedFormFactors = {
      allDevices: true,
      devices: GlobalConstants.ALL,
      manufacturer: GlobalConstants.ALL,
      processors: GlobalConstants.ALL,
      generations: GlobalConstants.ALL
    };
    const errorUrlExp = {
      urlValid: false,
    }
    this.tabIndex = -1;
    //Keep pages const and use same structure to reset
    if (which === 'error') {
      this.errorMessageBannerImage = { ...errorInit };
      this.errorMessageMainImage = { ...errorInit };
    } else if (which === 'image1') {
      this.imageMainData = { ...file };

    } else if (which === 'image2') {
      this.imageBannerData = { ...file };
    } else if (which === 'liveButton') {
      this.livePreview.button = { ...livePreviewInit.button };
      this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.CUSTOM_TILE, dataSet: this.livePreview });
    } else if (which === 'fromFact') {
      this.selectedFormFactors = { ...selectedFormFactors };
    } else {
      this.errorMessageBannerImage = { ...errorInit };
      this.errorMessageMainImage = { ...errorInit };
      this.imageMainData = { ...file };
      this.imageBannerData = { ...file };
      this.livePreview = { ...livePreviewInit };
      this.selectedFormFactors = { ...selectedFormFactors };
      this.mainSaveDone = false;
      this.errorUrlExp = { ...errorUrlExp };
      this.publishValue = '';
      this.internalValue = '';
      this.callToAction = '';
      this.urlInput = '';
      this.bgColor = '#000000';
      this.gamingBgColor = '#000000';
      setTimeout(() => {
        this.docPages.nativeElement.checked = true;
        this.docUrl.nativeElement.checked = false;
        this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.CUSTOM_TILE, dataSet: this.livePreview });
      }, 0);
    }
    this.customTileInfo = true;
    this.customPublishDateResultCustomTile = GlobalConstants.NOW;
    this.customExpiryDateResultCustomTile = GlobalConstants.NEVER;
  }
  editPreFill() {
    let callToActionEdit = this.editObject.callToAction;
    let configurations = (typeof this.editObject.configurations == 'string') ? JSON.parse(this.editObject.configurations) : this.editObject.configurations;
    this.configarationEdit = configurations;
    //To show pages tabs on edit of content group
    for (let each of this.configarationEdit.contentGroupPages) {
      if (each.pageNum === 1) {
        this.pages.page1 = true;
      }
      if (each.pageNum === 2) {
        this.pages.page2 = true;
      }
      if (each.pageNum === 3) {
        this.pages.page3 = true;
      }
    }
    this.pagelen = Object.entries(this.pages).length;
    // set multifuctionTab 
    this.mainTileFunction = !configurations.customURL;
    if (!this.mainTileFunction) {
      this.pages = {};
      this.page = 1;
      this.tabIndex = 0;
    }
    this.urlInput = configurations.customURL;
    this.resetPageOrUrl();
    // set call to action 
    this.setFormData(5, callToActionEdit);
    this.livePreview.button.value = this.callToAction;
    //image setup
    this.imageMainData.fileName = configurations.imageFile;
    this.imageBannerData.fileName = configurations.gamingImageFile;
    this.imageMainData.file = 'dummyFile';
    this.imageBannerData.file = 'dummyFile';
    this.livePreview.image.url = `${environment.apiBaseUrlAsset}${this.url}${AssetLibraryConstants.SRT_HERO_TILES}${AssetLibraryConstants.SLASH}${this.editObject.id}${AssetLibraryConstants.SLASH}${AssetLibraryConstants.MAIN_TILE_IMAGE}`;
    this.livePreview.bgColor = configurations?.bgColor ? configurations?.bgColor : '#000000';
    this.livePreview.gamingBgColor = configurations?.gamingBgColor ? configurations?.gamingBgColor : '#000000';
    this.bgColor = configurations?.bgColor ? configurations?.bgColor : '#000000';
    this.gamingBgColor = configurations?.gamingBgColor ? configurations?.gamingBgColor : '#000000';
    this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.CUSTOM_TILE, dataSet: this.livePreview });
    // set published name 
    this.setFormData(1, configurations.publishedName);
    // set internal name
    if (configurations.internalName) {
      this.setFormData(2, configurations.internalName);
    }
    let formFactors = Utils.getFormFactorNames(configurations.formFactor);
    this.selectedFormFactors = formFactors;
  }
  openMainFuntionPopup(modal, data?) {
    if (data !== null && !data) {
      this.modalService.open(modal);
      this.resetPageOrUrl();
    }
    if (data) {
      this.mainTileFunction = !this.mainTileFunction;
      this.resetPageOrUrl();
      modal.close();
    }
    if (data === null) {
      this.resetPageOrUrl();
      modal.close();
    }
  }
  resetPageOrUrl() {
    if (!this.mainTileFunction && this.mainSaveDone) {
      this.setIndex(0);
      this.pages = {};
      this.contentGrpData.customHeroTile.configurations.contentGroupPages = [];
      this.livePreview.button.value = this.callToAction;
      setTimeout(() => {
        this.docPages.nativeElement.checked = false;
        this.docUrl.nativeElement.checked = true;
        if (this.imageMainData.url == '' && this.editObject) {
          this.livePreview.image.url = `${environment.apiBaseUrlAsset}${this.url}${AssetLibraryConstants.SRT_HERO_TILES}${AssetLibraryConstants.SLASH}${this.editObject.id}${AssetLibraryConstants.SLASH}${AssetLibraryConstants.MAIN_TILE_IMAGE}`;
        } else {
          this.livePreview.image.url = this.imageMainData.url;
        }
        this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.CUSTOM_TILE, dataSet: this.livePreview });
      }, 0);
    } else if (this.mainSaveDone) {
      this.urlInput = '';
      this.page = 1; // set pagination to 1
      this.pages.page1 = true;
      this.isPage3Created = this.checkPages();
      this.clickable = true;
      this.setIndex(4);
      setTimeout(_ => {
        this.docPages.nativeElement.checked = true;
        this.docUrl.nativeElement.checked = false;
      }, 0);
    } else {
      setTimeout(_ => {
        this.docPages.nativeElement.checked = this.mainTileFunction;
        this.docUrl.nativeElement.checked = !this.mainTileFunction;
      }, 0);

    }
  }
  setFormData(whichInput, data) {
    if (this.imageMainData.url == '' && this.editObject) {
      this.livePreview.image.url = `${environment.apiBaseUrlAsset}${this.url}${AssetLibraryConstants.SRT_HERO_TILES}${AssetLibraryConstants.SLASH}${this.editObject.id}${AssetLibraryConstants.SLASH}${AssetLibraryConstants.MAIN_TILE_IMAGE}`;
    } else {
      this.livePreview.image.url = this.imageMainData.url;
    }
    this.errorMessage(whichInput, data);
    if (whichInput === 0) {
      if (!this.mainSaveDone) {
        this.mainTileFunction = !this.mainTileFunction;
        this.resetPageOrUrl();
      } else {
        this.openMainFuntionPopup(data);
      }
    } else if (whichInput === 1) {
      this.publishValue = data;
      if(this.publishValue?.trim() === ''){
        this.publishValue = '';
      }
    } else if (whichInput === 2) {
      this.internalValue = data;
    } else if (whichInput === 3 && !this.errorMessageMainImage.isError) {
      this.getImage(whichInput, data);
    } else if (whichInput === 4 && !this.errorMessageBannerImage.isError) {
      this.getImage(whichInput, data);
    } else if (whichInput === 5) {
      this.callToAction = data;
      this.livePreview.button.value = this.callToAction;
      this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.CUSTOM_TILE, dataSet: this.livePreview });
      if (!this.callToAction) {
        this.initialValue('liveButton')
      }
    } else if (whichInput === 6 && !this.errorUrlExp.urlValid) {
      this.urlInput = data;
      if (this.imageMainData.url == '' && this.editObject) {
        this.livePreview.image.url = `${environment.apiBaseUrlAsset}${this.url}${AssetLibraryConstants.SRT_HERO_TILES}${AssetLibraryConstants.SLASH}${this.editObject.id}${AssetLibraryConstants.SLASH}${AssetLibraryConstants.MAIN_TILE_IMAGE}`;
      } else {
        this.livePreview.image.url = this.imageMainData.url;
      }
      this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.CUSTOM_TILE, dataSet: this.livePreview });
    }
  }
  errorMessage(whichInput, value) {
    if (whichInput === 1) {
      this.errorMessagePublish = {};
    } else if (whichInput === 2) {
      this.errorMessageinternal = {};
    } else if (whichInput === 4 || whichInput === 3) {
      value = value.files[0];
      const error = {
        sizeError: value ? (value.size > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB) && !this.cmnSer.isSizeContraintsEnabled : false,
        typeError: value ? (fileType =>
          fileType !== GlobalConstants.CONTENT_TYPE_JPEG &&
          fileType !== GlobalConstants.CONTENT_TYPE_PNG &&
          fileType !== GlobalConstants.CONTENT_TYPE_GIF &&
          fileType !== GlobalConstants.CONTENT_TYPE_JFIF &&
          fileType !== GlobalConstants.CONTENT_TYPE_JPG)(value.type.split('/')[1]) : false,
        fileError: value ? value.type.split('/')[0] !== GlobalConstants.FILE_TYPE_IMAGE : true,
        isError: false
      }
      if (whichInput === 3) {
        this.errorMessageMainImage = { ...error };
        this.errorMessageMainImage.isError = this.errorMessageMainImage.sizeError || this.errorMessageMainImage.typeError || this.errorMessageMainImage.fileError;
        this.initialValue('image1');
        this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.CUSTOM_TILE, dataSet: this.livePreview });
      } else {
        this.errorMessageBannerImage = { ...error };
        this.errorMessageBannerImage.isError = this.errorMessageBannerImage.sizeError || this.errorMessageBannerImage.typeError || this.errorMessageBannerImage.fileError;
        this.initialValue('image2');
      }
    } else if (whichInput === 5) {
      this.errorMessageCallToAction = {};
    } else if (whichInput === 6) {
      this.errorUrlExp.urlValid = !Utils.validateUrl(value);
      this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.CUSTOM_TILE, dataSet: this.livePreview });
    }
  }
  getImage(which, data) {
    const file: File = data.files[0];
    if (which === 3) {
      this.imageMainData.file = file;
      this.imageMainData.fileName = file.name;
    } else {
      this.imageBannerData.file = file;
      this.imageBannerData.fileName = file.name;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = _event => {
      if (which === 3) {
        this.imageMainData.url = reader.result;
        this.livePreview.image.url = this.imageMainData.url;
        this.livePreview.bgColor = this.bgColor;
        this.livePreview.gamingBgColor = this.gamingBgColor;
        this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.CUSTOM_TILE, dataSet: this.livePreview });
      } else {
        this.imageBannerData.url = reader.result;
      }
    };
  }
  openModal(modal: any) {
    modal.open();
  }

  closeModal(modal: any) {
    modal.close();
  }
  applyFormFactor(data) {
    this.selectedFormFactors = data;
    this.closeModal(this.formFactorsModal);
  }
  openFormFactorsModal() {
    this.openModal(this.formFactorsModal);
  }
  cancel() {
    this.initialValue();
    this.refresh.emit(true);
    this.editObject = null;
  }
  createCustomTile() {
    let formFactors = Utils.getFormFactorValues(this.selectedFormFactors);
    let payload = {
      publishedName: this.publishValue,
      internalName: this.internalValue,
      callToAction: this.callToAction,
      createdByUser: sessionStorage.getItem('email'),
      configurations: JSON.stringify({
        publishedName: this.publishValue,
        internalName: this.internalValue,
        publishTime: (this.customPublishDateResultCustomTile.toString() !== GlobalConstants.NOW) ?
          Utils.changeSaveDateFormat(this.customPublishDateResultCustomTile.toString()) : Utils.getCurrentDate(),
        expireTime: (this.customExpiryDateResultCustomTile.toString() !== GlobalConstants.NEVER) ?
          Utils.changeSaveDateFormat(this.customExpiryDateResultCustomTile.toString()) : GlobalConstants.NEVER,
        isPublishDateNow: !this.isPublishDateCustomDatepickerCustomTile,
        isPublishExpiryNever: !this.isExpiryDatePickerCustomTile,
        type: this.assetLibrabyConstant.CUSTOM_TILE_GROUP,
        imageFile: this.imageMainData.fileName,
        gamingImageFile: this.imageBannerData.fileName,
        formFactor: formFactors,
        customURL: "",
        contentGroupPages: [],
        bgColor: this.bgColor,
        gamingBgColor: this.gamingBgColor
      })
    }
    this.heroTileService.createCustomTile(payload)
      .subscribe(res => {
        this.uploadImage(res);
        this.mainSaveDone = true;
        this.newID = res.customHeroTile;
        this.getAllInputs = res.customHeroTile; //edited content group
        this.configarationEdit = JSON.parse(res.customHeroTile.configurations);
        // if (typeof data === 'object' && data.cancel) {
        //   this.setIndex(1);
        //   this.pages = {};
        //   this.editCheck = false;
        // } else {
        this.contentGrpData = res;
        if (typeof this.contentGrpData.customHeroTile.configurations === 'string') {
          this.contentGrpData.customHeroTile.configurations =
            JSON.parse(this.contentGrpData.customHeroTile.configurations)
          // as LogoContentConfiguration;
        }
        this.page = 1; // set pagination to 1
        this.pages.page1 = true;
        this.isPage3Created = this.checkPages();
        // this.showLogContentName = this.contentGrpData.customHeroTile.configurations.publishedName;
        this.clickable = true;
        this.resetPageOrUrl();
      });

  }
  checkExpiryDateTime() {
    if (this.customExpiryDateResultCustomTile !== GlobalConstants.NEVER) {
      this.isExpiredDateIncorrectCustomTile = Utils.customDateCheck(this.customPublishDateResultCustomTile, this.customExpiryDateResultCustomTile);
    }
  }
  customValidation() {
    if (this.isPublishDateCustomDatepickerCustomTile) {
      this.isCustomPublishDateCorrectCustomTile = (this.customPublishDateResultCustomTile === GlobalConstants.NOW);
    }
    if (this.isExpiryDatePickerCustomTile) {
      this.isCustomExpiryDateCorrectCustomTile = (this.customExpiryDateResultCustomTile === GlobalConstants.NEVER);
    }
  }
  getLogoContentPublishDate(data) {
    this.customPublishDateResultCustomTile = Utils.formatDate(data);
  }

  getLogoContentExpiryDate(data) {
    this.customExpiryDateResultCustomTile = Utils.formatDate(data);
  }
  checkIfTimeset(data, check) {
    if (data[0] && data[1]) {
      (check === 'publish') ? (this.isCustomPublishDateCorrectCustomTile = false) : (this.isCustomExpiryDateCorrectCustomTile = false);
    }
  }
  selectCustomPublishDate(datetimeOption) {
    this.isPublishDateCustomDatepickerCustomTile = Utils.isCustomStatus(datetimeOption);
    if (!this.isPublishDateCustomDatepickerCustomTile && this.customPublishDateResultCustomTile !== GlobalConstants.NOW) {
      this.customPublishDateResultCustomTile = Utils.getCurrentDate();
    }
    if (datetimeOption === GlobalConstants.NOW) {
      this.isCustomPublishDateCorrectCustomTile = false;
      this.isCustomPublishTimeZoneSelected = false;
    }
  }
  selectExpiryDateTimeZone(datetimeOption) {
    this.isExpiryDatePickerCustomTile = Utils.isCustomStatus(datetimeOption);
    if (!this.isExpiryDatePickerCustomTile && this.customExpiryDateResultCustomTile !== GlobalConstants.NEVER) {
      this.customExpiryDateResultCustomTile = GlobalConstants.NEVER;
    }
    if (datetimeOption === GlobalConstants.NEVER) {
      this.isExpiredDateIncorrectCustomTile = false;
      this.isCustomExpiryDateCorrectCustomTile = false;
      this.isCustomExpiryTimeZoneSelected = false;
    }
  }
  uploadImage(res) {
    this.heroTileService.uploadImage(this.imageMainData.file, res.customHeroTile.id, this.assetLibrabyConstant.MAIN_TILE_IMAGE, this.imageMainData.file.type.split('/')[0])
      .subscribe(res => {
      });
    this.heroTileService.uploadImage(this.imageBannerData.file, res.customHeroTile.id, this.assetLibrabyConstant.GAMING_IPOS_BANNER, this.imageBannerData.file.type.split('/')[0])
      .subscribe(res => {
        this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.CUSTOM_TILE, dataSet: this.livePreview });
      });

  }
  urlexpSave() {
    let payload = {
      publishedName: this.getAllInputs.publishedName,
      internalName: this.getAllInputs?.internalName,
      callToAction: this.getAllInputs.callToAction,
      createdByUser: sessionStorage.getItem('email'),
      configurations: ''
    }
    let config: any;
    if (typeof this.getAllInputs.configurations === 'string') {
      config = JSON.parse(this.getAllInputs.configurations);
    } else {
      config = this.getAllInputs.configurations;
    }
    config.customURL = this.urlInput;
    config.contentGroupPages = [];
    payload.configurations = JSON.stringify(config);
    this.heroTileService.updateCustomTile(payload, this.getAllInputs.id)
      .subscribe((putCustomContentResponse: CreateCustomTileResponse) => {
        this.deviceExists = putCustomContentResponse?.customHeroTile?.deviceExists;
        if (this.presentPage === this.assets_page && this.deviceExists) {
          this.openModal(this.applyModal);
        }
        if (!this.deviceExists) {
          this.cancel();
        }
      })
  }

  updateMetaPage() {
    let config = (typeof this.editObject.configurations == 'string') ? JSON.parse(this.editObject.configurations) : this.editObject.configurations;
    let formFactors = Utils.getFormFactorValues(this.selectedFormFactors);
    let payload = {
      publishedName: this.publishValue,
      internalName: this.internalValue,
      callToAction: this.callToAction,
      createdByUser: sessionStorage.getItem('email'),
      configurations: JSON.stringify({
        publishedName: this.publishValue,
        internalName: this.internalValue,
        publishTime: (this.isPublishDateCustomDatepickerCustomTile) ?
          Utils.changeSaveDateFormat(this.customPublishDateResultCustomTile.toString()) : Utils.getCurrentDate(),
        expireTime: (this.customExpiryDateResultCustomTile.toString() !== GlobalConstants.NEVER) ?
          Utils.changeSaveDateFormat(this.customExpiryDateResultCustomTile.toString()) : GlobalConstants.NEVER,
        isPublishDateNow: !this.isPublishDateCustomDatepickerCustomTile,
        isPublishExpiryNever: !this.isExpiryDatePickerCustomTile,
        type: this.assetLibrabyConstant.CUSTOM_TILE_GROUP,
        imageFile: this.imageMainData.fileName,
        gamingImageFile: this.imageBannerData.fileName,
        formFactor: formFactors,
        customURL: this.urlInput,
        contentGroupPages: config.contentGroupPages,
        bgColor : this.bgColor,
        gamingBgColor : this.gamingBgColor
      })
    }
    this.heroTileService.updateCustomTile(payload, this.editObject.id)
      .subscribe(res => {
        this.mainSaveDone = true;
        this.getAllInputs = res.customHeroTile;
        this.configarationEdit = JSON.parse(res.customHeroTile.configurations);
        this.contentGrpData = res;
        if (typeof this.contentGrpData.customHeroTile.configurations === 'string') {
          this.contentGrpData.customHeroTile.configurations =
            JSON.parse(this.contentGrpData.customHeroTile.configurations)
        }
        this.resetPageOrUrl();
        if (this.imageMainData.file !== 'dummyFile') {
          this.heroTileService.uploadImage(this.imageMainData.file, res.customHeroTile.id, this.assetLibrabyConstant.MAIN_TILE_IMAGE, this.imageMainData.file.type.split('/')[0])
            .subscribe(res => { });
        }
        if (this.imageBannerData.file !== 'dummyFile') {
          this.heroTileService.uploadImage(this.imageBannerData.file, res.customHeroTile.id, this.assetLibrabyConstant.GAMING_IPOS_BANNER, this.imageBannerData.file.type.split('/')[0])
            .subscribe(res => { });
        }
        this.livePreview.image.url = `${environment.apiBaseUrlAsset}${this.url}${AssetLibraryConstants.SRT_HERO_TILES}${AssetLibraryConstants.SLASH}${this.editObject.id}${AssetLibraryConstants.SLASH}${AssetLibraryConstants.MAIN_TILE_IMAGE}`;
        this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.CUSTOM_TILE, dataSet: this.livePreview });
      });
  }
  save() {
    this.isCustomPublishDateCorrectCustomTile = this.isPublishDateCustomDatepickerCustomTile && this.customPublishDateResultCustomTile === "Now"
    this.isCustomExpiryDateCorrectCustomTile = this.isExpiryDatePickerCustomTile && this.customExpiryDateResultCustomTile === "Never"
    this.checkExpiryDateTime();
    if (!this.isCustomPublishDateCorrectCustomTile && !this.isCustomExpiryDateCorrectCustomTile && !this.isExpiredDateIncorrectCustomTile &&
      !this.isCustomPublishTimeZoneSelected && !this.isCustomExpiryTimeZoneSelected) {
      if (this.mainSaveDone) {
        if (this.tabIndex === 0) {
          this.urlexpSave();
        }
      } else {
        if (this.editObject) {
          this.updateMetaPage()
        } else {
          this.createCustomTile();
        }
      }
    }
  }
  setIndex(value: number) {
    this.tabIndex = value;
  }
  addPage() {
    const keyLen = Object.keys(this.pages).length;
    if (keyLen === 0) {
      this.pages.page1 = true;
      this.setIndex(4);
    } else if (keyLen === 1) {
      this.pages.page2 = true;
      this.setIndex(5);
    } else {
      this.pages.page3 = true;
      this.setIndex(6);
    }
    this.isPage3Created = this.checkPages();
    this.pagelen = Object.entries(this.pages).length;
  }
  checkPages() {
    if (this.pages.page1 && this.pages.page2 && this.pages.page3) {
      return true;
    }
    return false;
  }
//delete pages IIT2-490
  openPopup(modal, pageNumber) {
    this.modalService.open(modal);
    this.whichPageDelete = pageNumber;
  }
  deletePages(which) {
    this.isPage3Created = false;
    let pagesLen = Object.entries(this.pages).length;
    this.pagelen = Object.entries(this.pages).length;
    if (pagesLen > 1) {
      delete this.pages["page" + (pagesLen)];
      this.pagelen -= 1;
    } else {
      this.page1.updated(undefined,undefined,'',1);
    }
    let configurations;
    let updatedPages = [];
    
    if (typeof this.contentGrpData.customHeroTile.configurations === 'string') {
      configurations = JSON.parse(this.contentGrpData.customHeroTile.configurations);
    } else {
      configurations = this.contentGrpData.customHeroTile.configurations;
    }
    configurations.contentGroupPages.splice(which, 1);
    configurations.contentGroupPages.forEach((e, i) => {
      e.pageNum = i + 1;
      updatedPages.push(e);
    });

    if (this.page1) {
      this.page1.updated(configurations,AssetLibraryConstants.SRT_HERO_TILES,'customTile');
    } else if (this.page2) {
      this.page2.updated(configurations,AssetLibraryConstants.SRT_HERO_TILES,'customTile');
    } else {
      this.page3.updated(configurations,AssetLibraryConstants.SRT_HERO_TILES,'customTile');
    }
  }

  /*when user opens pages*/
  setPreviewLayout(data) {
    this.LCGlayout = data;
  }
  /*when users slects layout*/
  setLayout(selected) {
    this.LCGlayout = selected;
    this.cmnSer.emitLayout(selected);
  }
  refreshLGCdata() {
    // this.getAllLogoContentsByUser(); Should navigate to completed.
    this.setIndex(1);
    this.mediaObjects = [];
  }
  openPopupError(modal) {
    this.modalService.open(modal);
  }
  getPageError(data) {
    this.pageError.set(data[1], data[0])
  }
  resetPage() {
    this.pageError = new Map([[1, false], [2, false], [3, false]]);
  }
  goToErrorPage() {
    if (this.pageError.get(1) === true) {
      this.tabIndex = 4
    } else if (this.pageError.get(2) === true) {
      this.tabIndex = 5
    } else {
      this.tabIndex = 6
    }
  }

  updateCustomTile() {

    if (typeof this.contentGrpData.customHeroTile.configurations === 'string') {
      this.contentGrpData.customHeroTile.configurations =
        JSON.parse(this.contentGrpData.customHeroTile.configurations)
    }
    const updatecustomTileContent = this.contentGrpData;
    const customTileContent = updatecustomTileContent.customHeroTile;
    if (typeof customTileContent.configurations !== 'string') {
      customTileContent.configurations.customURL = "";
      customTileContent.configurations = JSON.stringify(customTileContent.configurations);
    }
    this.heroTileService.updateCustomTile(JSON.stringify(customTileContent), customTileContent.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async (putLogoContentResponse: CreateCustomTileResponse) => {
        // Once the update call is successful, call a PUT call for the logo
        for (const each of this.mediaObjects) {
          if (each.uploaded) {
            await this.updateMedia(each);
          }
        }
        this.deviceExists = putLogoContentResponse.customHeroTile.deviceExists;
        
        if (this.presentPage === this.profile_page) {
          this.openModal(this.showModal);
        } else if (this.presentPage === this.assets_page && this.deviceExists) {
          this.openModal(this.applyModal);
        } else {
          this.pages = {};
          this.clickable = false;
          this.refresh.emit(true);
        }
        
      },
        error => {
        }
      );
  }

  updateMedia(each) {
    return new Promise((resolve, reject) => {
      this.heroTileService.putS3CustomTileContentByPageId(each.media.fileObj,
        each.media.name.split('.')
          .pop(), each.id, each.pageNum.toString())
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(
          (data) => {
            resolve(data);//To-Do: we should handle what if response code is other than 200
          },
          error => { // do something
          }
        );
    });
  }

  // To hold all pages media objects and its metada.
  prepareMediaSet(res: any, id: string) {
    const checkJson = this.checkExistance(this.mediaObjects, 'pageNum', res.number);
    if (checkJson.hasMatch) {
      // Update the pages
      this.mediaObjects[checkJson.matchedIndex] = {
        id: id,
        media: res.data.media,
        pageNum: res.number
      };
      if (typeof res.data.media.fileObj === 'object' && res.data.media.fileObj) {
        this.mediaObjects[checkJson.matchedIndex].uploaded = true;
      }
    } else {
      const dataObj: any = {
        id: id,
        media: res.data.media,
        pageNum: res.number
      };
      if (typeof res.data.media.fileObj === 'object' && res.data.media.fileObj) {
        dataObj.uploaded = true;
      }
      this.mediaObjects.push(dataObj);
    }
  }

  checkExistance(data, key, compValue) {
    const checkJSON = {
      hasMatch: false,
      matchedIndex: -1
    };
    if (data?.length) {
      for (let index = 0; index < data.length; index += 1) {
        if (data[index][key] === compValue) {
          checkJSON.hasMatch = true;
          checkJSON.matchedIndex = index;
          break;
        }
      }
    }

    return checkJSON;
  }

  fontSizeNumber(size) {
    if (size === GlobalConstants.SMALL) { return 12; }
    if (size === GlobalConstants.MEDIUM) { return 14; }
    if (size === GlobalConstants.LARGE) { return 16; }
  }

  getUILayoutNameByID(id) {// TODO - Confirm with Sujay if layout name is correct
    if (id === 1) {
      return '2_col_right_asset';
    } else if (id === 2) {
      return '2_col_left_asset';
    } else if (id === 3) {
      return '1_col_mid_asset';
    }
  }
  disableSaveButton() {
    let checkPages = this.checkPages();
    if (checkPages) {
      return false;
    } else {
      if (!this.publishValue || !this.callToAction || !this.selectedFormFactors || !this.imageMainData.file || !this.imageBannerData || ((this.errorUrlExp.urlValid || !this.urlInput) && this.mainSaveDone)) {
        return false;
      }
      else {
        return true;
      }
    }
  }

  redirectToApplyList() {
    this.pages = {};
    this.clickable = false;
    this.closeModal(this.applyModal);
    this.refresh.emit(true);
  }

  showOnDevice() {
    this.pages = {};
    this.clickable = false;
    this.closeModal(this.showModal);
    this.showOnDeviceTile.emit(true);
  }

  closeShowOnDevice() {
    this.closeModal(this.showModal);
    this.closeCustomDevice.emit(true);
  }
  ontabChange(which) {
    if (which === 2) {
      this.mainSaveDone = true;
      this.getAllInputs = this.editObject;
    } else {
      this.mainSaveDone = false;
      this.editObject = this.getAllInputs ? this.getAllInputs : this.editObject;
      if (typeof this.editObject.configurations === 'string') {
        this.editObject.configurations = JSON.parse(this.editObject.configurations);
      }
      if (!this.editObject.configurations.contentGroupPages.length) {
        this.pages = {}
      }
      this.clickable = false;
      this.page = 1;
      this.tabIndex = -1;
      setTimeout(_ => {
        this.editPreFill();
      }, 0)
    }
  }

  applyToDevice(applyDevice: boolean) {
    const updatecustomTileContent: CreateCustomTileResponse = this.contentGrpData as CreateCustomTileResponse;
    // Once page is updated.
    const customTileContent = updatecustomTileContent.customHeroTile;
    if (typeof customTileContent.configurations !== 'string') {
      customTileContent.configurations = JSON.stringify(customTileContent.configurations);
    }
    customTileContent.ispushedToDevice = applyDevice;
    customTileContent.showOnDevice = applyDevice;
    if (!applyDevice) {
      customTileContent.deviceExists = false;
    }
    else {
      customTileContent.deviceExists = this.deviceExists;
    }
    this.heroTileService.updateCustomTile(JSON.stringify(customTileContent), updatecustomTileContent.customHeroTile.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async (putLogoContentResponse: CreateCustomTileResponse) => {
        this.redirectToApplyList();
      },
        error => {
        });
  }

  checkTimeZone(data, check) {
    (check === GlobalConstants.PUBLISH) ? (this.isCustomPublishTimeZoneSelected = !data) : (this.isCustomExpiryTimeZoneSelected = !data);
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  emitPageDataToPreview() {
    this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.CUSTOM_TILE, dataSet: {bgColor : this.bgColor} });
  }
  emitPageGamingDataToPreview(){}
}

